import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {EXAMPLE_BOOKMARK_API_URL} from '../../defines/protocol';
import {ApiService} from '../api/api.service';
import {ExampleService} from './example.service';


@Injectable({
  providedIn: 'root'
})
export class ExampleBookmarkService extends ExampleService {

  constructor(
    protected override api: ApiService,
  ) {
    super(api);
    this.urlApi = EXAMPLE_BOOKMARK_API_URL;
  }

  /**
   * 예문을 책갈피에 추가/삭제하는 프로토콜을 서버에 전송한다.
   * @param id 추가할 예문 ID
   * @param add 추가/삭제 여부
   */
  public sendBookmark(id: string, add: boolean = true): Observable<boolean> {
    const url = this.urlApi + id + '/';
    const obs = add ?
      this.api.Post(url, null) :
      this.api.Delete(url);

    return obs.pipe(
      map(data => {
        console.log('sendBookmark', id, add, data);
        return data;
      }),
    );
  }

  /**
   * 지정한 예문을 표시 목록에서 제거한다.
   * @param id 제거할 예문 ID
   */
  public hideBookmark(id: string): void {
    if (this.totalCount === null) {
      throw new Error('ExampleBookmarkService::hideBookmark() totalCount is null');
    }
    if (this.listExample === null) {
      throw new Error('ExampleBookmarkService::hideBookmark() listExample is null');
    }

    const idx = this.listExample.findIndex(example => example.id === id) ?? -1;
    if (idx !== -1) {
      this.listExample.splice(idx, 1);
      --this.totalCount;
    }
    else {
      console.warn(`ExampleBookmarkService::hideBookmark(${id}) example does not exist`);
    }
  }
}
